import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { numToPrice, pexios, validate, toast } from '../../utils/functions';
import { history } from '../../utils/variables';
import { setRouterData } from '../../redux/actions';
import Pricing from '../../components/expert/Pricing';
import Input from "../../components/master/Input";
import { useTranslation } from 'react-i18next';

export default function RegisterPricing() {

    const form = useRef(null);

    const user = useSelector(store => store.user);
    const { id } = useSelector(store => store.routerData);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [items, setItems] = useState({
        accessories: [],
        registerAccessories: [],
    });
    const [selectedItems, setSelectedItems] = useState({
        options: [],
        damaged: [],
        replaced: [],
    });
    const [textData, setTextData] = useState({
        insuranceValue: '',
        visitingPlace: '',
        description: '',
    });
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        pexios('api/get_report_option', 'get')
            .then(res => {
                setItems(prevState => ({
                    ...prevState,
                    accessories: res.data.accessories,
                }));
            });
        pexios('api/get_register_accessory', 'get')
            .then(res => {
                setItems(prevState => ({
                    ...prevState,
                    registerAccessories: res.data,
                }));
            });
    }, []);

    function submitValue(type, data) {
        setSelectedItems(prevState => ({
            ...prevState,
            [type]: data,
        }));
    }
    function changeValue(value, type) {
        const text = type === 'insuranceValue' ? numToPrice(value) : value;
        setTextData(prevState => ({
            ...prevState,
            [type]: text,
        }));
    }
    function submit() {
        const err = validate(form);
        if (err.length) {
            // toast(`فیلد های اجباری ${err} را پر کنید.`, 'error');
            toast(t('Complete required fields',{err:err}), 'error');
            return;
        }
        setLoader(true);
        pexios('api/update_register','post',{
            id,
            damages: JSON.stringify(selectedItems.damaged),
            accessories: JSON.stringify(selectedItems.options),
            rebuilds: JSON.stringify(selectedItems.replaced),
            description: textData.description,
            insurance_value: textData.insuranceValue,
            place: textData.visitingPlace,
        })
            .then(() => {
                dispatch(setRouterData({}));
                toast(t('Greeting expert alert',{fullname :user.full_name}))
                // toast(`همکار محترم، جناب ${user.fname} ${user.lname} از این که ما را در کارشناسی این خسارت یاری نمودید سپاسگزاریم.با آرزوی روزی پر انرژی برای شما.`);
                setTimeout(() => {
                    history.replace('/expert-waiting');
                }, 5000);
            });
    }

    return (
        <div className='content final-pricing details pt20'>
            <Pricing
                value={selectedItems.options}
                title={t('Fake accessories')}
                placeholder={t('Accessory title')}
                pickerData={items.registerAccessories}
                submit={(value) => submitValue('options', value)}
            />
            <Pricing
                value={selectedItems.damaged}
                title={t('Damaged accessories')}
                placeholder={t('Accessory title')}
                pickerData={items.accessories}
                unit='percent'
                submit={(value) => submitValue('damaged', value)}
            />
            <Pricing
                value={selectedItems.replaced}
                title={t('Exchange accessories')}
                placeholder={t('Accessory title')}
                pickerData={items.accessories}
                unit='quality'
                submit={(value) => submitValue('replaced', value)}
            />
            <div className='row text-right' ref={form}>
                <Input
                    label={t('Final current vehicle price rial')}
                    value={textData.insuranceValue}
                    required
                    onChange={value => changeValue(value, 'insuranceValue')}
                    mode='numeric'
                    type='price'
                />
                <Input
                    label={t('Visit place')}
                    value={textData.visitingPlace}
                    required
                    onChange={value => changeValue(value, 'visitingPlace')}
                />
            </div>
            <div className='mt20 register-description-info mr10'>
                <p>1-{t('Add extra description')}</p>
                <p className='mt5'>2-{t('Add possible damages')}</p>
                <p className='mt5'>3-{t('Describe exchange accessories')}</p>
            </div>
            <div className='mt10 text-right'>
                <label>{t('Description')}</label>
                <div className='input-parent rtl mt5'>
                <textarea
                    value={textData.description}
                    rows='4'
                    placeholder={t('Description')}
                    onChange={(e) => changeValue(e.target.value, 'description')}
                />
                </div>
            </div>
            <div className='d-flex justify-center'>
            <button
                className='btn w-50 btn-white-purple btn-circle mt20'
                disabled={loader && 'disabled'}
                onClick={submit}>
                {
                    loader ?
                        <i className='fas fa-spinner fa-spin' /> :
                        t('Final confirm')
                }
            </button>
            </div>
        </div>
    );

}
